import { ApiClient } from '@tolstoy/utils/apiClients';

export const StudioApiClient = new ApiClient(process.env.NEXT_PUBLIC_API_URL!, 'studio');
export const AccountServiceClient = new ApiClient(process.env.NEXT_PUBLIC_API_URL!, 'account-service');
